/**
 * Gating for the experimental lazy-caching service worker test.
 * Remove once testing is complete — see app.module.ts.
 */

/**
 * Parses the comma-separated experiment user ID list from the environment
 * config (environment.experimentalServiceWorkerUserIds).
 */
export function parseExperimentalSwUserIds(
  userIds: string,
): ReadonlySet<string> {
  return new Set(userIds.split(',').filter(Boolean));
}

/**
 * Whether the given user is in the experimental lazy SW caching test.
 * Everyone else must keep getting the standard ngsw-worker.js.
 */
export function isExperimentalSwUser(
  userId: string,
  experimentalUserIds: ReadonlySet<string>,
): boolean {
  return experimentalUserIds.has(userId);
}

/**
 * Cookie that opts the current browser into the experimental SW so QA and the
 * Android e2e suite can exercise the experimental path with any user. Only
 * honoured outside prod — prod exposure is only ever the hardcoded ID list.
 */
export const EXPERIMENTAL_SW_OPT_IN_COOKIE = 'ENABLE_EXPERIMENTAL_NGSW=true';

export const EXPERIMENTAL_SW_SCRIPT = 'ngsw-worker-experimental.js';

/**
 * Whether the experimental SW is the one driving the page, i.e. no route bundle
 * has been prefetched. Takes the script URL of the controlling SW, if any.
 */
export function isExperimentalSwControlling(
  controllerScriptUrl: string | undefined,
): boolean {
  return controllerScriptUrl?.includes(EXPERIMENTAL_SW_SCRIPT) ?? false;
}

/**
 * Decides which service worker the current user gets. See app.module.ts.
 */
export function shouldUseExperimentalSw({
  userId,
  experimentalUserIds,
  cookies,
  allowCookieOptIn,
}: {
  userId: string;
  experimentalUserIds: ReadonlySet<string>;
  cookies: string;
  allowCookieOptIn: boolean;
}): boolean {
  if (allowCookieOptIn && cookies.includes(EXPERIMENTAL_SW_OPT_IN_COOKIE)) {
    return true;
  }
  return isExperimentalSwUser(userId, experimentalUserIds);
}
